document.addEventListener('DOMContentLoaded', () => {
  initBudgetRedirect();
  initJudgeReviewRedirect();
});

function initBudgetRedirect() {
  const isPDP = window.ShopifyAnalytics?.meta?.page?.pageType === 'product' || 
                document.body.classList.contains('template-product') ||
                window.location.pathname.includes('/products/');
  if (!isPDP) return;

  function checkAndRedirect(valueOrText) {
    if (!valueOrText) return;
    const cleanValue = valueOrText.trim().replace(/\s+/g, ' ');
    if (cleanValue === '$2,500 and below' || cleanValue === '$2,500 & below') {
      window.location.href = '/collections/art-prints';
    }
  }

  document.addEventListener('globo.formbuilder.form.submitted', function(event) {
    const form = event.detail.form;
    if (!form) return;

    // Scan all select dropdowns in the submitted form to check the chosen budget
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) {
        checkAndRedirect(selectedOption.text);
        checkAndRedirect(selectedOption.value);
      }
    });
  });
}

function initJudgeReviewRedirect() {
  // Capture click events on Judge.me review text elements and redirect to /pages/happy-customers
  document.addEventListener('click', function(e) {
    const judgeReviewTarget = e.target.closest('.jdgm-all-reviews-text, .jdgm-all-reviews-text--style-text, [class*="jdgm-all-reviews-text"]');
    if (judgeReviewTarget) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.location.href = '/pages/happy-customers';
    }
  }, true);

  function updateJudgeReviewLinks() {
    const containers = document.querySelectorAll('.jdgm-all-reviews-text, [class*="jdgm-all-reviews-text"]');
    containers.forEach(container => {
      if (container.tagName === 'A') {
        container.setAttribute('href', '/pages/happy-customers');
      }
      const links = container.querySelectorAll('a');
      links.forEach(link => {
        link.setAttribute('href', '/pages/happy-customers');
      });
    });
  }

  updateJudgeReviewLinks();

  if (document.body) {
    const observer = new MutationObserver(() => {
      updateJudgeReviewLinks();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
